import { PaperProps } from '@mui/material'
import { useEffect, useMemo, useState } from 'react'

export function usePaperProps($root: HTMLElement | null): PaperProps {
  const [width, setWidth] = useState(() => 0)

  useEffect(() => {
    if (!$root) return

    const updateWidth = () => {
      setWidth($root.offsetWidth ?? 0)
    }

    // Initial width update
    updateWidth()

    // Create a MutationObserver to watch for changes in the DOM
    const observer = new MutationObserver(updateWidth)
    observer.observe($root, { attributes: true, childList: true, subtree: true })

    // Cleanup observer on unmount
    return () => {
      observer.disconnect()
    }
  }, [$root])

  return useMemo(
    () => ({
      style: {
        minWidth: width,
        maxWidth: width * 2,
      },
      elevation: 6,
    }),
    [width],
  )
}
